import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=5fbeccea&"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports